import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';

class Article extends Component {
    render() {
        const articleId = this.props.match.params.articleId;
        return (
            <article>
                {/*
                    FIXME: Don't depend on webpack details here
                    https://github.com/facebook/create-react-app/issues/1944#issuecomment-316081906
                */}
                <ReactMarkdown source={require(`!raw-loader!./articles/${articleId}.md`)} />
            </article>
        );
    }
}

export default Article;



// WEBPACK FOOTER //
// ./src/Article.js